import { createContext, createElement, type PropsWithChildren, type ReactElement, useContext } from 'react';

const CommerceEnabledContext = createContext(true);

export function CommerceEnabledProvider({ enabled, children }: PropsWithChildren<{ enabled: boolean }>): ReactElement {
    return createElement(CommerceEnabledContext.Provider, { value: enabled }, children);
}

export function useCommerceEnabled(): boolean {
    return useContext(CommerceEnabledContext);
}
